
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface CompanySizeFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export function CompanySizeFilter({ value, onChange }: CompanySizeFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Company Size</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded-sm">
          <SelectValue placeholder="Select size" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded-sm">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All sizes</SelectItem>
          {["1-10", "11-50", "51-200", "201-500", "501-1000", "1001+"].map((size) => (
            <SelectItem key={size} value={size} className="text-foreground hover:bg-accent">
              {size} employees
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
